import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Container from "../../../common/Container";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import ihub from "../../../assets/images/ihub.jpg";

const Ihub = () => {
  return (
    <Box bgcolor={"#fff"}>
      <Helmet>
        <title>
          {" "}
          Use Case for Digital Infrastructure and Data Center Solutions
        </title>
      </Helmet>
      <AppBar
        position={"sticky"}
        elevation={0}
        sx={{
          backgroundColor: "#fff",
          padding: "10px 0px",
        }}
      >
        <Container paddingY={{ xs: 1 / 2, sm: 1 }}>
          <Header />
        </Container>
      </AppBar>
      <Container bgcolor={"#fff"}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"flex-start"}
          flexWrap={"wrap"}
        >
          <Box
            width={{ xs: "100%", sm: "80%" }}
            padding={{ xs: "25% 0% 10% 0%", sm: "2% 0%" }}
            marginLeft={{ xs: "0%", sm: "0%" }}
          >
            <Box display={"flex"} alignItems={"center"} marginBottom={"2%"}>
              <Box
                component="img"
                height={{ xs: "28vh", sm: "550px" }}
                width={{ xs: "100%", sm: "100%" }}
                marginTop={{ xs: "20%", sm: "0%" }}
                src={ihub}
                alt={"ihub_img"}
                sx={{
                  objectFit: "cover",
                  borderRadius: "30px",
                }}
              />
            </Box>
            <Typography
              variant="h4"
              color={"#39484E"}
              fontWeight={700}
              paddingBottom={{ xs: "2%", sm: "1%" }}
              textAlign={"left"}
            >
              CASE 3: iHub, Kenya
            </Typography>
            <Typography
              variant="h6"
              color={"#4f4f4f"}
              fontWeight={700}
              paddingBottom={{ xs: "5%", sm: "2%" }}
              textAlign={"left"}
            >
              Use Case for Digital Infrastructure and Data Center Solutions
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              iHub, based in Nairobi, Kenya is a pioneering example of how
              innovation hubs can transform local economies and address systemic
              challenges. Since its establishment, iHub has provided vital
              support to startups, developers, and entrepreneurs through
              resources such as mentorship, funding opportunities, and tailored
              programs like coding bootcamps and AI workshops. The hub has
              cultivated a thriving ecosystem where innovators can scale
              impactful solutions for public health, education, and disaster
              management. Notably, iHub's role in fostering the creation of
              mobile money platform M-Pesa highlights its ability to catalyze
              transformative change.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              Over the years, iHub has incubated more than 150 startups,
              contributing to the creation of over 40,000 jobs and drawing $50
              million in venture capital. AIR Fund support of innovation hubs
              inspired by iHub’s model could provide a critical solution to
              these challenges. An AIR Fund-supported hub in Arusha, for
              example, could create local programs tailored to agritech
              solutions, leveraging the city’s role as a regional agricultural
              center. In Gulu, a hub could focus on post-conflict economic
              recovery by nurturing startups that address gaps in education,
              healthcare, and infrastructure. By addressing local needs, these
              hubs would empower youth to innovate while stimulating economic
              activity in underserved regions.
            </Typography>
          </Box>
        </Box>
      </Container>
      <Box bgcolor={"#213555"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Ihub;
